import { render, staticRenderFns } from "./manage-pr.vue?vue&type=template&id=26b5ad0b&"
import script from "./manage-pr.vue?vue&type=script&lang=js&"
export * from "./manage-pr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports